import type { ModuleRoute } from '../types';
import { AgreementsPage } from './AgreementsPage';
import { PublicVerifyPage } from './PublicVerifyPage';

/** Pages of this area. Owned by Phase 1 task W7; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/agreements', element: <AgreementsPage />, permission: 'agreements.view' },
  { path: '/verify', element: <PublicVerifyPage />, public: true },
];
